import React from 'react';
import {ExecuteModalProps} from '../../types';

const ExecuteModal: React.FC<ExecuteModalProps> = ({
                                                       isOpen,
                                                       onClose,
                                                       selectedAgent,
                                                       testCases,
                                                       selectedTestsForRun,
                                                       results,
                                                       isTestRunning,
                                                       aiConfig,
                                                       onRunTests,
                                                       onSelectAllTests,
                                                       onSelectSingleTest,
                                                       onOpenApiConfig
                                                   }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content data-editor-modal execute-modal" style={{ width: '95vw', maxWidth: '1400px' }} onClick={e => e.stopPropagation()}>
                <h2>🚀 Execute AI-Driven Tests</h2>
                {!aiConfig?.testwerk_api_key_configured && (
                    <div className="ai-warning">
                         AI services not configured. <button className="pushable push-warning btn-sm"
                                                               onClick={onOpenApiConfig}>
                        <span className="shadow"></span>
                        <span className="edge"></span>
                        <span className="front">Set up now</span>
                    </button>
                    </div>
                )}
                <div className="execute-modal-controls">
                    <h3>Test Execution Mode</h3>
                    <div className="control-group radio-group-horizontal">
                        <label><input type="radio" name="test-mode" value="intelligent" defaultChecked/>  Intelligent
                            AI Validation</label>
                        <label><input type="radio" name="test-mode" value="simulation"/> 🎭 Advanced Simulation
                            Mode</label>
                        <label><input type="radio" name="test-mode" value="compliance"/>  Compliance Testing</label>
                    </div>
                </div>
                <div className="test-case-selection-list">
                    <h3>Test Cases for: {selectedAgent}</h3>
                    <div className="control-group">
                        <label>
                            <input
                                type="checkbox"
                                onChange={onSelectAllTests}
                                checked={testCases.length > 0 && selectedTestsForRun.length === testCases.length}
                            />
                            <strong>Select All ({testCases.length} tests)</strong>
                        </label>
                    </div>
                    <hr/>
                    <div className="checkbox-list">
                        {testCases.map(tc => (
                            <label key={tc} className="test-checkbox">
                                <input
                                    type="checkbox"
                                    value={tc}
                                    checked={selectedTestsForRun.includes(tc)}
                                    onChange={(e) => onSelectSingleTest(tc, e.target.checked)}
                                />
                                <span className="test-name">{tc}</span>
                                {results.get(tc) && (
                                    <span className={`test-status ${results.get(tc)?.status?.toLowerCase()}`}>
                                        {results.get(tc)?.status}
                                    </span>
                                )}
                            </label>
                        ))}
                    </div>
                </div>
                <div className="execution-preview">
                    <h4>Execution Preview</h4>
                    <p>Selected: <strong>{selectedTestsForRun.length}</strong> tests</p>
                    <p>AI Model: <strong>{aiConfig?.default_model || 'Not configured'}</strong></p>
                    <p>Estimated time: <strong>{(selectedTestsForRun.length * 3).toFixed(1)}s</strong></p>
                </div>
                <div className="modal-actions">
                    <button className="pushable push-secondary" onClick={onClose}>
                        <span className="shadow"></span>
                        <span className="edge"></span>
                        <span className="front">Cancel</span>
                    </button>
                    <button
                        className="pushable push-primary"
                        onClick={onRunTests}
                        disabled={isTestRunning || selectedTestsForRun.length === 0}
                    >
                        <span className="shadow"></span>
                        <span className="edge"></span>
                        <span
                            className="front">{isTestRunning ? ' Running...' : `Run (${selectedTestsForRun.length}) Selected`}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExecuteModal;